export const dashboardGraphsOptions = {
  BarChartChartOptions: {
    fonts: [],
    bars: 'horizontal',
    colors: ['#08305D', '#6A98DD'],
    legend: { textStyle: { fontSize: 13 }, position: "top" },
    vAxis: {
      minValue: 0,
      format: 'short',
     textStyle: {
        fontSize: 13,
        textOverflow: 'ellipsis',
        maxLines: 1,
      },
      textWrap: 'none',
      maxTextLines: 1,
      titleTextStyle: { fontSize: 13 },
    },
    hAxis: {
      minValue: 0,
      maxValue: 100,
      format: "#'%'",
      title: '',
      textStyle: { fontSize: 13 },
      ticks: [0, 25, 50, 75, 100],
      titleTextStyle: { fontSize: 13 },
    },
    GetByColumnLength: (columns: string[], customTitles?: { h?: string, v?: string }) => 
      dashboardGraphsOptions.setChartOptionsByDataLength(dashboardGraphsOptions.BarChartChartOptions, columns, customTitles),
  },
  
  ColumnChartOptions: {
    fonts: [],
    chartArea: { width: '80%' },
    vAxis: {
      minValue: 0,
      format: 'short',
      textStyle: { fontSize: 13 },
      titleTextStyle: { fontSize: 13 },
    },
    hAxis: {
      title: '',
      gridlines: { count: 6 },
      textStyle: { fontSize: 13 },
      titleTextStyle: { fontSize: 13 },
    },
    colors: ['#08305D', '#6A98DD'],
    annotations: {
      alwaysOutside: true,
      textStyle: { fontSize: 13 },
    },
    allowHtml: true,
    legend: { textStyle: { fontSize: 13 }, position: 'top' },
    GetByColumnLength: (columns: string[], customTitles?: { h?: string, v?: string }) => 
      dashboardGraphsOptions.setChartOptionsByDataLength(dashboardGraphsOptions.ColumnChartOptions, columns, customTitles),
  },
  
  BarChartOptions: {
    fonts: [],
    chartArea: { width: '80%', height: '70%' },
    hAxis: {
      title: '',
      gridlines: { count: 6 },
      textStyle: { fontSize: 13 },
      titleTextStyle: { fontSize: 13 },
    },
    vAxis: {
      minValue: 0,
      format: 'short',
     textStyle: {
        fontSize: 13,
        textOverflow: 'ellipsis',
        maxLines: 1,
      },
      textWrap: 'none',
      maxTextLines: 1,
      titleTextStyle: { fontSize: 13 },
    },
    colors: ['#08305D', '#6A98DD'],
    areaOpacity: 0.3,
    isStacked: true,
    lineWidth: 2,
    legend: { textStyle: { fontSize: 13 }, position: 'top' },
    GetByColumnLength: (columns: string[], customTitles?: { h?: string, v?: string }) => 
      dashboardGraphsOptions.setChartOptionsByDataLength(dashboardGraphsOptions.BarChartOptions, columns, customTitles),
  },
  
  TableChartOptions: {
    fonts: [],
    width: '100%',
    innerHeight: '100%',
    allowHtml: true,
    colors: ['#08305D', '#6A98DD'],
    showRowNumber: false,
    scrollPolicy: 'vertical',
    cssClassNames: {
      headerRow: 'custom-header-google-tables',
      tableCell: 'custom-rows-google-tables',
    },
    columnWidthMode: 'auto',
    legend: { textStyle: { fontSize: 13 } },
    GetByColumnLength: (columns: string[], customTitles?: { h?: string, v?: string }) => 
      dashboardGraphsOptions.setChartOptionsByDataLength(dashboardGraphsOptions.TableChartOptions, columns, customTitles),
  },
  
  PieChartOptions: {
    fonts: [],
    chartArea: { width: '80%' },
    vAxis: {
      minValue: 0,
      format: 'short',
      textStyle: { fontSize: 13 },
      titleTextStyle: { fontSize: 13 },
    },
    hAxis: {
      title: '',
      gridlines: { count: 6 },
      textStyle: { fontSize: 13 },
      titleTextStyle: { fontSize: 13 },
    },
    colors: [
       "#8A8C8E", '#08305D', '#6A98DD', "#eba7a9","#bd8d57",
    ],
    bar: { groupWidth: '90%' },
    legend: { textStyle: { fontSize: 13 } },
    tooltip: {
      isHtml: true,
      textStyle: { fontSize: 13 },
      trigger: 'focus',
    },
    GetByColumnLength: (columns: string[], customTitles?: { h?: string, v?: string }) => 
      dashboardGraphsOptions.setChartOptionsByDataLength(dashboardGraphsOptions.PieChartOptions, columns, customTitles),
  },
  
  setChartOptionsByDataLength: (chartOptions: any, columns: string[], customTitles?: { h?: string, v?: string }) => {
    const options = JSON.parse(JSON.stringify(chartOptions)); // Deep copy to prevent mutations

    if (customTitles) {
      const { h, v } = customTitles;
      if (h) options.hAxis.title = h;
      if (v) options.vAxis.title = v;
    }
    
    if (columns?.length < 3) {
      options.legend = { ...options.legend, position: 'none' };
    }
    
    return options;
  },
};

export const pageFilterOptionsDefaultState = {
  Organisations: [],
  Role: [],
  Site: [],
  Users: [],
  'Site/Region': [],
  Courses: [],
  Author: '',
  Authors: [],
  startDate: '',
  endDate: '',
  Ratings: [],
  Credits: '',
  invertData: "Most completed",
  "eLearning/Events": [],
  // Remove default range values to prevent unnecessary API calls
  // These will only be added when user actually changes the range
  withCourses: "true",
  orgsWithCredits: "true",
  completedCourses: "true",
  mostCompletedUser:  "true",
};

export const getStars = (count: number) => "⭐⭐⭐⭐⭐".substring(0, count);


export const GOOGLE_CHARTS_TYPES = {
  BAR: "Bar",
  TABLE: "Table",
  GAUGE: "Gauge",
  SANKEY: "Sankey",
  TREEMAP: "TreeMap",
  BARCHART: "BarChart",
  GEOCHART: "GeoChart",
  PIECHART: "PieChart",
  ORGCHART: "OrgChart",
  TIMELINE: "Timeline",
  WORDTREE: "WordTree",
  CALENDAR: "Calendar",
  LINECHART: "LineChart",
  AREACHART: "AreaChart",
  HISTOGRAM: "Histogram",
  COMBOCHART: "ComboChart",
  COLUMNCHART: "ColumnChart",
  BUBBLECHART: "BubbleChart",
  SCATTERCHART: "ScatterChart",
  STEPPEDAREACHART: "SteppedAreaChart",
  CANDLESTICKCHART: "CandlestickChart",
} as const;

export const googleChartsTypes = Object.values(GOOGLE_CHARTS_TYPES);

export type googleChartsTypesType = typeof googleChartsTypes[number];